// Canonical global geography list for GCFE / IDFC.
// The 27 IDFC members invest across ALL emerging & developing markets — not only Africa.
// Country VALUES are stored in English (matching compares these strings against project.country).
// Display can be localized via countryLabel() in lib/localize.js.

export const GEO_REGIONS = [
  {
    key: 'ssa',
    label: { en: 'Sub-Saharan Africa', fr: 'Afrique subsaharienne' },
    countries: [
      'Senegal', "Côte d'Ivoire", 'Benin', 'Ghana', 'Nigeria', 'Mali', 'Togo',
      'Cameroon', 'Kenya', 'Ethiopia', 'Tanzania', 'Uganda', 'Rwanda',
      'Zambia', 'Zimbabwe', 'South Africa',
    ],
  },
  {
    key: 'mena',
    label: { en: 'North Africa & Middle East', fr: 'Afrique du Nord & Moyen-Orient' },
    countries: ['Morocco', 'Egypt', 'Tunisia', 'Algeria', 'Jordan', 'Lebanon'],
  },
  {
    key: 'asia',
    label: { en: 'Asia & Pacific', fr: 'Asie & Pacifique' },
    countries: [
      'India', 'Indonesia', 'Vietnam', 'Bangladesh', 'Philippines',
      'Pakistan', 'Sri Lanka', 'Nepal', 'Cambodia', 'Mongolia',
    ],
  },
  {
    key: 'latam',
    label: { en: 'Latin America & Caribbean', fr: 'Amérique latine & Caraïbes' },
    countries: [
      'Brazil', 'Mexico', 'Colombia', 'Peru', 'Argentina', 'Chile',
      'Panama', 'Ecuador', 'Dominican Republic',
    ],
  },
  {
    key: 'eca',
    label: { en: 'Europe & Central Asia', fr: 'Europe & Asie centrale' },
    countries: ['Turkey', 'Ukraine', 'Georgia', 'Kazakhstan', 'Uzbekistan', 'Serbia'],
  },
];

// Flat, ordered list of all country values (regions kept in geographic order).
export const ALL_COUNTRIES = GEO_REGIONS.flatMap((r) => r.countries);

export const regionLabel = (region, lang) => (lang === 'fr' ? region.label.fr : region.label.en);
